import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChange = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Change",
		children: /* @__PURE__ */ _jsx("path", {
			id: "ð¨ Color",
			d: "M1.37947 10.0028L4.37597 13.1961C4.55335 13.3851 4.83087 13.4024 5.02662 13.248L5.08271 13.1965L8.08594 10.0032C8.28142 9.79533 8.28176 9.45797 8.08671 9.24967C7.90939 9.06031 7.63164 9.04279 7.43574 9.19733L7.37961 9.24885L5.23103 11.5341L5.23147 3.22531C5.23147 2.95557 5.04337 2.73265 4.79932 2.69737L4.73147 2.6925C4.47834 2.6925 4.26915 2.89295 4.23604 3.15301L4.23147 3.22531L4.23103 11.5356L2.0866 9.24927C1.90909 9.06011 1.63132 9.0429 1.43557 9.19766L1.37949 9.24925C1.20197 9.4384 1.18583 9.7344 1.33106 9.94299L1.37947 10.0028ZM11.6658 13.3543L11.7336 13.3592C11.9867 13.3592 12.1959 13.1587 12.229 12.8987L12.2336 12.8264L12.233 4.51743L14.3793 6.80577C14.5568 6.99501 14.8345 7.01233 15.0303 6.85765L15.0864 6.80608C15.264 6.61701 15.2803 6.32101 15.1351 6.11236L15.0867 6.05258L12.0892 2.85575C11.9118 2.66651 11.634 2.64919 11.4382 2.80387L11.3821 2.85543L8.37963 6.05227C8.18428 6.26025 8.18415 6.59761 8.37933 6.80577C8.55677 6.99501 8.83454 7.01233 9.03034 6.85765L9.08644 6.80608L11.233 4.52027L11.2336 12.8264C11.2336 13.0961 11.4217 13.319 11.6658 13.3543Z",
			fill: "white"
		})
	})
});
const ForwardRef = forwardRef(SvgChange);
export default ForwardRef;
